import React, { useContext, useEffect } from 'react';
import { IComponentPageTabType, IComponentType, IConfigData} from '@/pages/dashboard/components/PageContainer/type';
import { buriedPoint, typeIdObj } from '@/pages/home/utils/buriedPoint';
import Render from '@/pages/dashboard/components/PageContainer/Render';
import { shallowEqual, useParams, useSelector } from 'umi';
import { StudioContext } from '../../context';
import { IData, IRootState, IStudioParams } from '../../type';

interface IContentWrapProps {
  config: IComponentPageTabType;
  children?: React.ReactElement<{
    name?: string;
    config?: IComponentType;
    data?: IConfigData;
    changeData?: (key: string, value: unknown) => void;
  }>[];
  tabId?: string;
  tabRightSlotData?: string;
  data: IData;
}

// 跑马灯、打点等相关处理
const CommonLogWrap = (props: IContentWrapProps) => {
  const { config, children = [], data, ...restProps } = props;
  const { logConfig } = config || {};
  const { studioId, gameCode } = useParams<IStudioParams>();
  const frameType = useSelector(
    (state: IRootState) => state.studio?.frameType,
    shallowEqual,
  );
  const { currentGame } = useContext(StudioContext);

  useEffect(() => {
    const {
      pageId,
      pageName,
      extInfo,
      pagePath,
      typeId = typeIdObj.studio,
      uidType,
      ...otherLogConfig
    } = logConfig || {};
    if (!logConfig || !frameType || !studioId) return;
    const logObj = {
      pageId,
      pageName,
      extInfo,
      pagePath,
      typeId,
      uid:
        frameType === 'game' ? gameCode : studioId,
      uidType: frameType === 'game' ? 'game_code' : 'studio_id',
      gameName: frameType === 'game' ? currentGame?.game_name : '',
      ...otherLogConfig,
    };
    buriedPoint(logObj);
  }, [logConfig, frameType, gameCode, studioId, currentGame]);

  return <>
    {
      children?.map((item, index) => {
        const { config, data, changeData } = item?.props || {};
        return <>
          <Render
            config={config}
            logConfig={logConfig}
            key={item?.name + index}
            data={data}
            changeData={changeData}
            tabFilter={restProps?.tabRightSlotData}
            tabId={restProps?.tabId}
          />
        </>;
      })
    }
  </>;
};

export default CommonLogWrap;
